import React from 'react';
import NoneGiven from './none_given';
import DimensionsMissing from './dimensions_missing';
import MissingTyreIndexPostcode from './missing_tyre_index_and_postcode';
import MissingSpeedIndex from './missing_speed_index';
import MissingLoadIndex from './missing_load_index';
import MissingTyreIndex from './missing_tyre_index';
import MissingPostcode from './missing_postcode';
import AllGiven from './all_given';
import StatusbarConstants from '../../../../constants/statusbar_constants';

function currentStatusFactory(status, filters, postcodeExistsButNeedsToBeLoaded, onClick, onLearnMoreClick, onChange) {
    switch (status) {
        case StatusbarConstants.ALL_MISSING:
            return <NoneGiven onClick={onClick} onChange={onChange} filters={filters} postcodeExistsButNeedsToBeLoaded={postcodeExistsButNeedsToBeLoaded} />;
        case StatusbarConstants.DIMENSIONS_MISSING:
            return <DimensionsMissing onClick={onClick} />;
        case StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING:
            return <MissingTyreIndexPostcode onClick={onClick} />;
        case StatusbarConstants.SPEED_INDEX_MISSING:
            return <MissingSpeedIndex onClick={onClick} />;
        case StatusbarConstants.LOAD_INDEX_MISSING:
            return <MissingLoadIndex onClick={onClick} />;
        case StatusbarConstants.TYRE_INDEX_MISSING:
            return <MissingTyreIndex onClick={onClick} />;
        case StatusbarConstants.POSTCODE_MISSING:
            return <MissingPostcode onClick={onClick} />;
        case StatusbarConstants.NONE_MISSING:
            return <AllGiven onLearnMoreClick={onLearnMoreClick} />;
        default:
            return null;
    }
}

export default currentStatusFactory;